import React from 'react';

const CTA = () => {
  return (
    <div className="bg-white font-sans text-gray-800">
    
      {/* 3. ENHANCED CTA FOOTER HOOK */}
      <section className="relative py-24 px-6 md:px-12 mx-4 md:mx-8 mb-8 rounded-[3rem] overflow-hidden text-center text-white">
        
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center"></div>
        <div className="absolute inset-0 bg-[#1a3b5c]/90 backdrop-blur-sm"></div>

        <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center">
          
          {/* Decorative Icon Wrapper */}
          <div className="inline-block p-3 bg-white/10 rounded-2xl mb-8 backdrop-blur-md border border-white/20 text-white">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
            </svg>
          </div>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
            ¿Listo para transformar <br className="hidden md:block" /> la educación?
          </h2>
          
          <p className="text-blue-100 text-lg md:text-xl mb-10 leading-relaxed max-w-2xl font-light">
            Agenda una reunión con nuestros especialistas y descubre cómo implementar estos programas en tu institución.
          </p>
          
          <a href="https://calendly.com/avconsulting-info/30min?month=2026-03" target="_blank" rel="noopener noreferrer">
            <button className="group bg-white text-[#1a3b5c] hover:bg-blue-50 px-10 py-5 rounded-full font-bold text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:shadow-blue-900/20 transform hover:-translate-y-1 flex items-center gap-3">
              <span>Agendar Asesoría Gratuita</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
              </svg>
            </button>
          </a>
        </div>
      </section>

    </div>
  );
};

export default CTA;